import React, { useEffect, useRef, useState } from "react";
import { TableWrapper } from "../../Components/styledConstant";
import LocalLoader from "../../Components/Loader/LocalLoader";
import { FilterWrapper } from "../../assets/styles/FilterStyle";
import { AlertWrapper } from "../../assets/styles/AlerWrapper";
import { Link, useNavigate } from "react-router-dom";
import { CSVLink } from "react-csv";
import DatePicker from "react-datepicker";
import Pagination from "../../Components/Pagination/Pagination";
import { getDateFromDateObj, isEmpty, pdfData } from "../../utils/common";
import animationData1 from "../../assets/lotties/question.json";
import {
  cdmCardList,
  cdmUpdateStatus,
} from "../../utils/api";
import ModalData from "../../Components/ModalData/ModalData";
import DateRangePicker from "../../Components/DateRangePicker/DateRangePicker";

const CDMCardInventory = () => {
  const [downloadLoader, setDownloadLoader] = useState("");
  const [showfilter, setShowFilter] = useState("");
  const [fromDate, setStartDate] = useState("");
  const [toDate, setEndDate] = useState("");
  const [currPage, setCurrPage] = useState(0);
  const [totalElements, setTotalElements] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(null);
  const [inventoryData, setInventoryData] = useState();
  const [assigneeDevice, setAssigneeDevice] = useState();
  const [pdfData_, setPdfData] = useState([]);
  const [status, setStatus] = useState("");
  const [message, setMessage] = useState();
  const [update, setUpdate] = useState({});
  const [cardNumber, setCardNumber] = useState("");
  const navigate = useNavigate();
  const link = useRef();

  const defaultOptions1 = {
    loop: true,
    autoplay: true,
    animationData: animationData1,
  };
      const clearRef = useRef(null);
  const clearDate = (callback) => {
    if (clearRef.current) return;
    clearRef.current = callback;
  };

  const constChangeDate = (startDate, endDate) => {
    if (endDate) {
      setEndDate(endDate);
      setStartDate(startDate);
    }
  };

  const onClearDate = () => {
    setEndDate("");
    setStartDate("");
  };

  const handleInventoryData = async (key,page = null,cardStatus) => {
    let _fromDate = "";
  let _toDate = "";

  if (fromDate !== "" && toDate !== "") {
    _fromDate = getDateFromDateObj(fromDate, "YYYY-MM-DD");
    _toDate = getDateFromDateObj(toDate, "YYYY-MM-DD");
  }
    let param = {
      page: currPage,
      size: pageSize,
      cardNumber: cardNumber,
      fromDate: _fromDate,
      toDate: _toDate,
    
    };
 if(page !== null){
  param.page = page;
  setCurrPage(page)
 }
 setStatus(cardStatus);
    if (!isEmpty(cardStatus) && key !== "refresh") {
      param.status = cardStatus;
    }
    if(key === "refresh"){
      param = {
        page: 0,
        cardNumber: "",
        fromDate: "",
        toDate: "",
      };
      dataRefresh();
    }

    if(key === "CSV"){
      setDownloadLoader("CSV");
      param.size = totalElements;
    }else if(key === "PDF"){
      setDownloadLoader("PDF");
      param.size = totalElements;
    }else{
      setLoading(true);
    }
   

    cdmCardList(param).then((resp) => {
      setLoading(false);
      setDownloadLoader("");
      if (resp?.data.success) {
        if (key === "CSV") {
          setPdfData(resp?.data?.data?.content);
          setTimeout(() => {
            const csvlink = link.current;
            csvlink.link.click();
          }, 100);
        } else if (key === "PDF") {
          userlistPdfData(resp?.data?.data?.content);
        } else {
          setInventoryData(resp?.data?.data?.content);
          setTotalPages(resp?.data?.data?.totalPages);
          setTotalElements(resp?.data?.data?.totalElements);
        }
      }
    });
  };

  useEffect(() => {
    handleInventoryData("pagination",0);
  }, []);

  const dataRefresh = () => {
    setStartDate("");
    setEndDate("");
    setCurrPage(0);
    setStatus(null);
    setCardNumber("");
       if (clearRef.current) {
      clearRef.current();
    }
  };

  const userlistPdfData = (data = []) => {
  
    const tableHeader = [
      {
        cardNumber: "Card Number",
        cardId: "card Id",
        createdDate: "Created Date",
        expiryDate: "Expiry Date",
        status: "Status"
       
      },
    ];

    pdfData(data, tableHeader, 'CDMinventoryList.pdf', );
  };

  //update device

  const updateDevice = () => {
    const param = {
      cardNumber: update.cardNumber,
    };

    cdmUpdateStatus(param).then((resp) => {
      setLoading(false);
      if (resp?.data?.success) {
        setMessage({ msg: "Status updated successfully.", type: "success" });

        handleInventoryData();
        setUpdate({});
      } else {
        let msg = "";
        if (resp?.data?.errorCodeList.length > 0) {
          msg = resp?.data?.errorCodeList[0];
        } else {
          msg = resp?.data?.msg;
        }
        setMessage({ msg: msg, type: "error" });
      }
    });
  };
  //Device Mapping
  const handleDataMapping = (data) => {
    setAssigneeDevice(data);
  };

  const deviceAssign = () => {
    navigate("/map-cdm-device", {
      state: {
        assigneeDevice: assigneeDevice,
      },
    });
  };



  return (
    <div>
      {message && (
        <AlertWrapper className="success globle">
          <span className="close" onClick={() => setMessage("")}>
            ×
          </span>
          {message.msg}
        </AlertWrapper>
      )}
      <div className="" style={{ padding: "30px" }}>
        <div className="userlist_head">
          <div className="userlist_heading">
            <div className="userlist_left">
              <label>CDM Card List</label>
            </div>
            <div className="userlist_right">
              {downloadLoader !== "PDF" ? (
                <button
                  className="pdf"
                  onClick={(e) => handleInventoryData( "PDF")}
                >
                  PDF
                </button>
              ) : (
                <button className="pdf">
                  <div className="btn-loader">
                    <i className="fa-solid fa-spinner"></i>
                  </div>
                </button>
              )}

              {downloadLoader !== "CSV" ? (
                <button
                  className="xls"
                  onClick={(e) => handleInventoryData("CSV")}
                >
                  CSV
                </button>
              ) : (
                <button className="xls">
                  <div className="btn-loader">
                    <i className="fa-solid fa-spinner"></i>
                  </div>
                </button>
              )}
              <CSVLink
                ref={link}
                data={pdfData_}
                filename="CDM_InventoryList.csv"
              ></CSVLink>
            </div>
            <div className="userlist_filter">
              <button
                className="filter fs-16"
                onClick={(e) =>
                  showfilter === "active"
                    ? setShowFilter("")
                    : setShowFilter("active")
                }
              >
                <i className="fa-solid fa-filter"></i>
              </button>
            </div>
          </div>
        </div>
        <FilterWrapper
          style={{ height: "auto" }}
          className={`display_data ${showfilter}`}
        >
          <div className="filterBox">
            <div style={{width:"100%"}}>
              <div className="flex align-items gap-15">
                <div>
                  <input
                    type="text"
                    name="cardNumber"
                    placeholder="Enter Card Number"
                    value={cardNumber}
                    onChange={(e) => setCardNumber(e.target.value)}
                    maxLength={16}
                  />
                </div>
                <div className="input-field">
                  <select
                    onChange={(e) =>   handleInventoryData("",0,e.target.value)}
                    value={status}
                    className="input_select_field"
                  >
                    <option value={""}>Status</option>
                    <option value="ACTIVE">Active</option>
                    <option value="INACTIVE">Inactive</option>
                  </select>
                </div>
                {/* <div className="input-field">
                  <div className="flex">
                    <DatePicker
                      showIcon
                      className="date-picker2 date_type"
                      placeholderText="From Date"
                      selected={fromDate}
                      selectsStart
                      startDate={fromDate}
                      endDate={toDate}
                      yearDropdownItemNumber={100}
                      scrollableYearDropdown={true}
                      showYearDropdown
                      onKeyDown={(e) => e.preventDefault()}
                      onChange={(date) => setStartDate(date)}
                      maxDate={new Date()}
                    />
                  </div>
                </div>
                <div className="input-field">
                  <div className="flex">
                    <DatePicker
                      showIcon
                      className="date-picker2 date_type"
                      placeholderText="To Date"
                      selected={toDate}
                      selectsEnd
                      startDate={fromDate}
                      endDate={toDate}
                      minDate={fromDate}
                      yearDropdownItemNumber={100}
                      scrollableYearDropdown={true}
                      showYearDropdown
                      onKeyDown={(e) => e.preventDefault()}
                      onChange={(date) => setEndDate(date)}
                      maxDate={new Date()}
                    />
                  </div>
                </div> */}
                  <DateRangePicker
                    applyDate={constChangeDate}
                    defaultDate={null}
                    onClear={onClearDate}
                    clearDate={clearDate}
                  />
                <div className="button">
                  <button
                    className="userlist_btn refresh-btn"
                    onClick={(e) => handleInventoryData("search")}
                  >
                    Search
                  </button>
                </div>
                <div className="button">
                  <Link to="/add-card">
                    <button className="userlist_btn">Add Device</button>
                  </Link>
                </div>
                <div className="button">
                  <button
                    className="refresh-btn"
                    onClick={(e) => handleInventoryData( "refresh")}
                  >
                    <i className="fa fa-refresh"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </FilterWrapper>

        {
          <div className="table-loader">
            {loading && <LocalLoader className="tableLoader" />}
            <TableWrapper className="table-card-wrapper">
              <table className="table">
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Card Number</th>
                    <th>Expiry Date</th>
                    <th>Created Date</th>
                    <th>Status</th>
                    <th>Action</th>
                    <th>Mapping</th>
                  </tr>
                </thead>
                <tbody>
                  {inventoryData?.map((item, index = 1) => {
                    const dateTimeString = item?.createdDate;
                    let [date, time] = dateTimeString?.split("T");
                    let newTime = time.slice(0, 8);
                    return (
                      <tr>
                        <td className="td-none">
                          <span className="card-th">Sr No</span>
                          <span>{index + 1}</span>
                        </td>

                        <td>
                          <span className="card-th">Card Number</span>
                          <span>{item?.cardNumber || "-"}</span>
                        </td>
                        <td>
                          <span className="card-th">Expiry Date</span>
                          <span>{item?.expiryDate || "-"}</span>
                        </td>
                        <td>
                          <span className="card-th">Created Date</span>
                          <span>{date + " " + newTime}</span>
                        </td>
                        <td>
                          <span className="card-th">Status</span>
                          <span>
                            <div
                              className={`${
                                item.status == "ACTIVE"
                                  ? "active_status"
                                  : "inactive_status"
                              }`}
                            >
                              {item?.status || "-"}
                            </div>
                          </span>
                        </td>

                        <td className="user_action_btn">
                          <span className="card-th">Actions</span>
                          <span className="center">
                            <div
                              className={`custom-toggle toggle_button ${
                                item.status === "ACTIVE" ? "active" : ""
                              }`}
                              onClick={() => setUpdate(item)}
                              styled={{
                                margin: "0",
                                marginRight: "12px",
                              }}
                            >
                              <div className="slider"></div>
                            </div>
                          </span>
                        </td>
                        <td className="user_action_btn">
                          <span className="card-th">Mapping</span>
                          <span className="center flex gap-10">
                            {item.status !== "ACTIVE" ? (
                              <button onClick={() => handleDataMapping(item)}>
                                <i className="fa-solid fa-mobile"></i>
                              </button>
                            ) : (
                              "Mapped"
                            )}
                          </span>
                        </td>
                      </tr>
                    );
                  })}

                  {!loading && inventoryData && inventoryData.length < 1 && (
                    <tr>
                      <td
                        colSpan={6}
                        style={{ textAlign: "center", color: "red" }}
                      >
                        No data found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </TableWrapper>
          </div>
        }
           <div style={loading ? { opacity: "0" } : { opacity: "1" }}>
        {totalPages > 1 && (
          <Pagination
            items={inventoryData}
            itemsPerPage={pageSize}
            setitemsPerPage={setPageSize}
            currentPage={currPage}
            setcurrentPage={(currPage) =>  handleInventoryData("pagination",currPage)}
            totalPages={totalPages}
          />
        )}
      </div>
      </div>
   
      {!isEmpty(update) && (
        <ModalData
          onClickCancel={() => setUpdate({})}
          onClickConfirm={() => updateDevice()}
          lottieOptions={defaultOptions1}
          heading1="You want to change the status of device?"
        />
      )}


      {!isEmpty(assigneeDevice) && (
        <ModalData
          onClickCancel={() => setAssigneeDevice({})}
          onClickConfirm={() => deviceAssign()}
          lottieOptions={defaultOptions1}
          heading1="You want to Assignee the Device?"
        />
      )}
    </div>
  );
};

export default CDMCardInventory;
